module.exports = __webpack_public_path__ + "img/peopleIcon.f244e85b.png";